module.exports = __webpack_public_path__ + "img/character_details.b17faa5d.png";